import React from 'react';
export function BonusSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    title: 'BONUS #1',
    name: 'Kit Premium de Evaluaciones de Filosofía',
    description: 'Sistema completo con banco de exámenes, evaluaciones integradoras, recuperaciones y criterios profesionales de corrección.',
    image: 'https://cdn.magicpatterns.com/uploads/coKZitNtUaiSWS651G6fMn/bono_1_.png'
  }, {
    title: 'BONUS #2',
    name: 'Actividades Filosóficas',
    description: 'Banco ampliado de actividades dinámicas, consignas de debate y propuestas participativas listas para usar.',
    image: 'https://cdn.magicpatterns.com/uploads/oXjxLsE3efGsUu5GcWTinC/bono_2_.png'
  }, {
    title: 'BONUS #3',
    name: 'Plantillas profesionales de planificación',
    description: 'Modelos editables para organizar tu año lectivo con claridad, estructura y respaldo pedagógico.',
    image: 'https://cdn.magicpatterns.com/uploads/wuJEDFTSwwCpo9mM5NUgEF/bono_3.png'
  }];
  return <section id="bonus" className="py-5 sm:py-14 bg-[#0f172a] relative" data-id="element-30">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-31">
        <div className="text-center mb-3 sm:mb-8" data-id="element-32">
          <h2 className="text-lg sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-4" data-id="element-33">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-xs sm:text-base text-gray-300 max-w-2xl mx-auto mb-3 sm:mb-6" data-id="element-34">
            Para que cuentes con respaldo profesional, evaluaciones sólidas y
            herramientas listas para implementar, incluimos 3 bonus
            estratégicos:
          </p>

          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-[10px] sm:text-base md:text-lg px-3 sm:px-6 py-1 sm:py-2 rounded-lg shadow-lg border-2 border-white/20" data-id="element-35">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6" data-id="element-36">
          {bonuses.map((bonus, index) => <div key={index} className="bg-[#1e293b] rounded-xl overflow-hidden border-2 border-[#fbbf24]/50 hover:border-[#fbbf24] transition-all shadow-xl flex flex-col" data-id="element-37">
              <div className="bg-[#fbbf24]/10 p-1.5 sm:p-3 text-center border-b border-[#fbbf24]/20" data-id="element-38">
                <h3 className="text-sm sm:text-xl font-bold text-[#fbbf24]" data-id="element-39">
                  {bonus.title}
                </h3>
              </div>
              <div className="p-2.5 sm:p-5 flex-1 flex flex-col items-center" data-id="element-40">
                <div className="w-full max-w-[160px] sm:max-w-[280px] aspect-square mb-2 sm:mb-4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-41">
                  <img src={bonus.image} alt={bonus.name} className="w-full h-full object-contain drop-shadow-2xl" data-id="element-42" />
                </div>
                <h4 className="text-sm sm:text-lg font-bold text-white mb-0.5 sm:mb-2 text-center leading-tight" data-id="element-43">
                  {bonus.name}
                </h4>
                <p className="text-gray-300 text-center text-[10px] sm:text-sm" data-id="element-44">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}